import React from "react";
import { GoogleButton } from "./GoogleButton";

export default React.memo(GoogleButton);
